export const eventsSlides = [
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Event%20logos/events-logo-1.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Event%20logos/events-logo-2.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Event%20logos/events-logo-3.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Event%20logos/events-logo-4.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Event%20logos/events-logo-5.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Event%20logos/events-logo-6.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Event%20logos/events-logo-7.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Event%20logos/events-logo-8.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Event%20logos/events-logo-9.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Event%20logos/events-logo-10.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Event%20logos/events-logo-1.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Event%20logos/events-logo-2.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Event%20logos/events-logo-3.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Event%20logos/events-logo-4.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Event%20logos/events-logo-5.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Event%20logos/events-logo-6.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Event%20logos/events-logo-7.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Event%20logos/events-logo-8.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Event%20logos/events-logo-9.png',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/images/Event%20logos/events-logo-10.png',
  },
]
export const homePageInfinteScrollSlides = [
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/rolzo-next/images/clients/home-logo-1.webp',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/rolzo-next/images/clients/home-logo-2.webp',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/rolzo-next/images/clients/home-logo-3.webp',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/rolzo-next/images/clients/home-logo-4.webp',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/rolzo-next/images/clients/home-logo-5.webp',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/rolzo-next/images/clients/home-logo-6.webp',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/rolzo-next/images/clients/home-logo-7.webp',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/rolzo-next/images/clients/home-logo-8.webp',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/rolzo-next/images/clients/home-logo-9.webp',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/rolzo-next/images/clients/home-logo-10.webp',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/rolzo-next/images/clients/home-logo-11.webp',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/rolzo-next/images/clients/home-logo-12.webp',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/rolzo-next/images/clients/home-logo-13.webp',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/rolzo-next/images/clients/home-logo-14.webp',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/rolzo-next/images/clients/home-logo-15.webp',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/rolzo-next/images/clients/home-logo-16.webp',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/rolzo-next/images/clients/home-logo-17.webp',
  },
  {
    img: 'https://storage.googleapis.com/rolzo-static-bucket/rolzo-next/images/clients/home-logo-18.webp',
  },
]
export const clientsImages = {
  nuba: 'https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/travel/logo-nuba.png',
  yourtraveldesigner:
    'https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/travel/logo-yourtraveldesigner.png',
  tripindependent:
    'https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/travel/logo-tripindependent.png',
  theconteclub:
    'https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/travel/logo-conte.png',
  velocity:
    'https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/Lifestyle/logo-velocityblack.png',
  tenlifestylegroup:
    'https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/Lifestyle/logo-ten.png',
  asklaura:
    'https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/Lifestyle/logo-asklaura.png',
  jkplaceparis:
    'https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/hospitality/logo-jk.png',
  '1000museum':
    'https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/hospitality/logo-onethousandmuseum.png',
  privadia:
    'https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/hospitality/logo-privadia.png',
  shyaviation:
    'https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/aviation/logo-shyaviation.png',
  theaviationfactory:
    'https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/aviation/logo-theaviationfactory.png',
  flybizconcierge:
    'https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/aviation/flybiz.png',
  tiffanyco:
    'https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/events/logo-tco.png',
  dolcegabbana:
    'https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/events/logo-dolce.png',
  diageo:
    'https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/events/logo-diageo.png',
}


export const citiesData = [
  {
    name: "London",
    route: "/cities/london",
    imageUrl: "https://storage.googleapis.com/rolzo-static-bucket/images/cities/1.png"
  },
  {
    name: "New York City",
    route: "/cities/new-york-ny",
    imageUrl: "https://storage.googleapis.com/rolzo-static-bucket/images/cities/2.png"
  },
  {
    name: "Zurich",
    route: "/cities/zürich",
    imageUrl: "https://storage.googleapis.com/rolzo-static-bucket/images/cities/3.png"
  },
  {
    name: "Amsterdam",
    route: "/cities/amsterdam",
    imageUrl: "https://storage.googleapis.com/rolzo-static-bucket/images/cities/4.png"
  },
  {
    name: "Stockholm",
    route: "/cities/stockholm",
    imageUrl: "https://storage.googleapis.com/rolzo-static-bucket/images/cities/5.png"
  },
  {
    name: "Seattle",
    route: "/cities/seattle-wa",
    imageUrl: "https://storage.googleapis.com/rolzo-static-bucket/images/cities/6.png"
  },
  {
    name: "Honolulu",
    route: "/cities/honolulu-hi",
    imageUrl: "https://storage.googleapis.com/rolzo-static-bucket/images/cities/7.png"
  },
  {
    name: "Los Angeles",
    route: "/cities/los-angeles-ca",
    imageUrl: "https://storage.googleapis.com/rolzo-static-bucket/images/cities/8.png"
  },
  {
    name: "Lyon",
    route: "/cities/lyon",
    imageUrl: "https://storage.googleapis.com/rolzo-static-bucket/images/cities/9.png"
  },
  {
    name: "Montreal",
    route: "/cities/montreal-qc",
    imageUrl: "https://storage.googleapis.com/rolzo-static-bucket/images/cities/10.png"
  },
  {
    name: "Aspen",
    route: "/cities/aspen-co",
    imageUrl: "https://storage.googleapis.com/rolzo-static-bucket/images/cities/11.png"
  },
  {
    name: "Lisbon",
    route: "/cities/lisbon",
    imageUrl: "https://storage.googleapis.com/rolzo-static-bucket/images/cities/12.png"
  },
  {
    name: "Gstaad",
    route: "/cities/gstaad",
    imageUrl: "https://storage.googleapis.com/rolzo-static-bucket/images/cities/13.png"
  },
  {
    name: "Tampa",
    route: "/cities/tampa-fl",
    imageUrl: "https://storage.googleapis.com/rolzo-static-bucket/images/cities/14.png"
  },
  {
    name: "Paris",
    route: "/cities/paris",
    imageUrl: "https://storage.googleapis.com/rolzo-static-bucket/images/cities/paris.png"
  }
];

export const officesImages = {
  UK: 'https://storage.googleapis.com/rolzo-static-bucket/images/offices/office-london.png',
  France: 'https://storage.googleapis.com/rolzo-static-bucket/images/offices/office-paris.png',
  US: 'https://storage.googleapis.com/rolzo-static-bucket/images/offices/ny-office.png',
  ChinaSAR: 'https://storage.googleapis.com/rolzo-static-bucket/images/offices/office-hongkong.png',
  UAE: 'https://storage.googleapis.com/rolzo-static-bucket/images/offices/office-dubai.png',
  Mexico: 'https://storage.googleapis.com/rolzo-static-bucket/images/offices/Artboard.png',
  Brazil: 'https://storage.googleapis.com/rolzo-static-bucket/images/offices/office-brazil.png',
}


export const companiesFeedbackImages = {
  "American Express": "https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/testimonials/Logo_1_Amex.png",
  "Aman": "https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/testimonials/Logo_9_Aman.png",
  "Quintessentially": "https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/testimonials/Logo_10_Quint.png",
  "Aspire": "https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/testimonials/Logo_8_Aspire.png",
  "Different-Planet-Travel": "https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/testimonials/Logo_3_DifferentPlanetTravel.png",
  "TENco": "https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/testimonials/Logo_4_TENCo.png",
  "Luxury-Travel-Society": "https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/testimonials/Logo_5_TheLuxuryTravelSociety.png",
  "Lozano": "https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/testimonials/Logo_6_LozanoTravel.png",
  "Escapes": "https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/testimonials/Logo_7_Escapes.png",
  "LURA": "https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/testimonials/Logo_12_Lura.png",
  "T-Journeys": "https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/testimonials/Logo_13_T-Journeys.png",
  "Helentours": "https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/testimonials/Logo_14_Helentours.png",
  "FlyClever": "https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/testimonials/Logo_15_FlyClever.png",
  "InnerPlace": "https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/testimonials/Logo_2_InnerPlace.png",
  "NUBA": "https://storage.googleapis.com/rolzo-static-bucket/images/useCasesIcons/testimonials/Logo_11_Nuba.png"
}

export const LATAM_COUNTRIES = [
  // South America
  'AR', // Argentina
  'BO', // Bolivia
  // 'BR', // Brazil  exclude brazil
  'CL', // Chile
  'CO', // Colombia
  'EC', // Ecuador
  'FK', // Falkland Islands
  'GF', // French Guiana
  'GY', // Guyana
  'PY', // Paraguay
  'PE', // Peru
  'SR', // Suriname
  'UY', // Uruguay
  'VE', // Venezuela

  // Central America & Mexico
  'BZ', // Belize
  'CR', // Costa Rica
  'SV', // El Salvador
  'GT', // Guatemala
  'HN', // Honduras
  'MX', // Mexico
  'NI', // Nicaragua
  'PA', // Panama

  // Caribbean (Romance language countries)
  'CU', // Cuba
  'DO', // Dominican Republic
  'HT', // Haiti
  'PR', // Puerto Rico
  'GP', // Guadeloupe
  'MQ', // Martinique
  'BL', // Saint Barthélemy
  'MF', // Saint Martin
  'PM', // Saint Pierre and Miquelon
  // spain
  'ES', // Spain

];

export const PORTUGAL_COUNTRIES = [
  'PT', // Portugal
  'BR', // Brazil
];

export const footerContact = {
  email: 'info@rolzo.com',
  phone: '+1 646 492 8394',
  whatsapp: '+1 646 492 8394',
}
